<template>
	<div id="productOptionList">


		<div id="desktop">


			<table style="width:100%;" cellspacing="1" cellpadding="0">
				<thead>
					<tr>
						<th>Artnr/EAN</th>
						<th v-for="(header) in this.headerList" :key="header.productOptionTypeId"
							:title="header.typeWeb + '/' + header.typeValue"> {{ header.typeWeb }}</th>
						<th>Lager</th>
						<th style="text-align:right;padding-right:10px;">
							<div v-if="this.isLoggedIn && this.displayPrice && this.sameDiscount" style="justify-content: end;" class="flexcenter link"
								@click="this.showDiscountInformationAll = !this.showDiscountInformationAll">
								Pris <div class="discountBadge" v-if="this" style="margin-left:5px;">
									{{ this.discountLabel }}
								</div>
							</div>

							<div v-else>Pris</div>


						</th>
						<th v-if="this.isLoggedIn"></th>
					</tr>
				</thead>
				<tbody v-for="(row, index) in this.productOptionModel?.rowList" :key="row.productOptionSet.productOptionSetId">
					<tr :class="{ odd: index % 2 === 0 }">
						<td :title="'Sort: ' + row.productOptionSet?.sort + ', POSID: ' + row.productOptionSet.productOptionSetId ">
							<b style="color:grey;">{{ this.formatArtnr(row.productOptionSet?.artnr)
								}}</b><br /><b style="font-size: 80%;color:grey;">{{
								row.productOptionSet?.ean }}</b>
						</td>

						<td v-for="(header) in this.headerList" :key="header.productOptionTypeId"> {{
							row.colMap.get(header.productOptionTypeId)?.value }}</td>
						<td >

							<div class="noInStock" :class="'noInStock_' + row.productOptionSet?.noInStockKey"
								style="color:white;padding:3px;border-radius: 5px;text-align:center;width:30px;">
								{{ this.noInStockSymbol(row.productOptionSet?.noInStockKey) }}
							</div>



						</td>
						<td :title="'pris: ' + row.productOptionSet?.price2"
							style="font-weight:bold;min-width:50px;text-align: right;padding-right:10px;padding-right:10px;">{{
							row.productOptionSet?.price2 }}&nbsp;kr

							<!-- åf pris -->
							<b v-if="this.isLoggedIn && this.displayPrice" style="color:grey;"><br />{{
								this.formatPrice1(row.productOptionSet?.price1) }} </b>

							<!-- discount badge 10% -->
							<div
								v-if="this.isLoggedIn && this.displayPrice && row.productOptionSet?.discountModel?.success && !this.sameDiscount">
								<div class="discountBadge link" style="display:inline;"
									@click="this.showDiscountInformationClicked(row.productOptionSet?.productOptionSetId)">{{
									row.productOptionSet?.discountModel?.label }}</div>
							</div>



						</td>
						<td v-if="this.isLoggedIn" style="text-align: center;">
							<div class="buyButton link" :class="this.buttonSelectable(row.productOptionSet.productOptionSetId) ? 'selectable' : '' " v-if="this.isLoggedIn" @click.stop="this.buy(row.productOptionSet)"
								style="">
								{{ this.buttonLabel(row.productOptionSet.productOptionSetId) }}
							</div>
						</td>
					</tr>
					<!-- discount information -->
					<tr
						v-if="this.isLoggedIn && !this.sameDiscount && this.displayPrice && row.productOptionSet?.discountModel?.success && this.showDiscountInformationList?.includes(row.productOptionSet?.productOptionSetId)">
						<td colspan="10">
							<DiscountModelView :discountModel="row.productOptionSet?.discountModel" />
						</td>
					</tr>

				</tbody>


			</table>

			<div v-if="this.isLoggedIn && this.displayPrice && this.sameDiscount && this.showDiscountInformationAll">
				<DiscountModelView :discountModel="this.firstDiscountModel" />

			</div>
		</div>

		<!-- tabell för mobil -->
		<div id="mobile" style="border:0px solid green;width:100%;">


			<table class="mobile-table-row" v-for="(row) in this.productOptionModel?.rowList"
				:key="row.productOptionSet.productOptionSetId"
				style="width:100%;margin-bottom: 20px;background:var(--grey-4);  ">

				<tr>
					<td colspan="2" style="background: var(--grey-4);"><b style="font-size:110%;">{{ this.formatArtnr(row.productOptionSet?.artnr)
							}}</b></td>
				</tr>


				<tr class="">
					<td class="label">EAN</td>
					<td class="data"> {{ row.productOptionSet?.ean }}</td>
				</tr>

				<!-- loopa rader med options -->
				<tr v-for="(header, index) in this.headerList" :key="header.productOptionTypeId"
					:class="{ odd: index % 2 === 0 }">
					<td class=" label">{{ header.typeValue }}</td>
					<td class="data">{{ row.colMap.get(header.productOptionTypeId)?.value }}</td>
				</tr>


				<tr>

					<td colspan="2" style="background:white;">

						<div class="flexcenter" style="align-items:center;justify-items: center;">
							<div style="flex-grow:1;flex-direction: column;align-items: start;" class="flexcenter">
								<h3>{{ row.productOptionSet?.price2 }}&nbsp;kr</h3>

								<div class="flexcenter" style="margin-top:5px;" v-if="this.isLoggedIn && this.displayPrice">

									<!-- discount badge 10% -->
									<div v-if="row.productOptionSet?.discountModel?.success" style="margin-right:5px;">
										<div class="discountBadge link" style=""
											@click="this.showDiscountInformationClicked(row.productOptionSet?.productOptionSetId)">{{
											row.productOptionSet?.discountModel?.label }}</div>



									</div>

									<!-- åf pris -->
									<b style="color:grey;">{{
										this.formatPrice1(row.productOptionSet?.price1) }} </b>



								</div>


							</div>

							<div class="flexcenter" style="margin-top:0px;">


								<b class="noInStockLabel"
									:class="'noInStock_' + row.productOptionSet?.noInStockKey">{{
									this.noInStockLabel(row.productOptionSet?.noInStockKey) }}</b>

								<Button v-if="this.isLoggedIn" :label="this.buttonLabel(row.productOptionSet.productOptionSetId)" @click="this.buy(row.productOptionSet)"
									style="padding-left:50px;padding-right:50px;margin-left:10px;" :class="this.buttonSelectable(row.productOptionSet.productOptionSetId) ? '' : 'grey' " />

							</div>
						</div>

					</td>
				</tr>

				<!-- discount information -->
				<tr
					v-if="this.isLoggedIn && this.displayPrice && row.productOptionSet?.discountModel?.success && this.showDiscountInformationList?.includes(row.productOptionSet?.productOptionSetId)">
					<td colspan="10">
						<DiscountModelView :discountModel="row.productOptionSet?.discountModel" />
					</td>
				</tr>



			</table>



		</div>
	</div>
</template>
<script>

//import { PRODUCT_STORE_ACTION } from '@/store/product-store';
//import EntityHeaderSort from "@/components/entity/EntityHeaderSort.vue";
//import listHelper from "@/helper/list-helper.js";
import { userMixin } from "@/mixins/userMixin.js";
import { productMixin } from "@/mixins/productMixin.js";
import { USER_STORE_GETTER } from "../../../store/user-store";
import DiscountModelView from "./DiscountModelView.vue";

export default {
	name: "ProductOptionList",
	components: { DiscountModelView  },
	mixins: [userMixin, productMixin],
	props: {
		productOptionModel: Object,
		dropshipActive:{
			type:Boolean,
			default: false
		},
		dropshipProductOptionSetId: Number
	},
	data() {
		return {
			showDiscountInformationList: [],
			showDiscountInformationAll: false

		};
	},
	computed: {

		headerList(){
			return this.productOptionModel?.headerList.filter(header => header != null);
		},
		get() {
			//return this.$store.state.productStore.data.productList.filter(product => product !== null);
			//return this.$store.getters[STORE_GETTER.UNREAD_ERROR_MESSAGE]
			return 1

		},

		displayPrice() {
			return this.$store.getters[USER_STORE_GETTER.DISPLAY_PRICE1];
		},

		sameDiscount(){

			var discountListIdSum = 0;
			var multiply = 0;

			// loopa alla options 
			for (const row of this.productOptionModel?.rowList){

				const discountModel = row?.productOptionSet?.discountModel

				console.log('FP: discountModel: ', discountModel);

				if (!discountModel){
					return false;
				}
				

				// om multiply skiljer åt på någon
				if (multiply == 0){

					multiply = discountModel?.multiply

				} else if (multiply != discountModel.multiply){
					//alert("Skiljer på multiply")
					return false;
				}

				var idSum = 0;

				for (const discount of  discountModel?.discountList){
					idSum = idSum + discount.discountId
				}

				// om idsumman inte stämmer 
				if (discountListIdSum == 0){
				
					discountListIdSum = idSum
				
				} else if (discountListIdSum != idSum){
					//alert("Skiljer på sum")
					return false;
				}


			}
			
		



			return true;

		},

		discountLabel(){
			return this.firstDiscountModel?.label;
		},

		firstDiscountModel(){

			return this.productOptionModel?.rowList?.find(row => row !== null)?.productOptionSet?.discountModel

		}

		//baseModel() {
		//	return this.$store.getters[STORE_GETTER.BASE_MODEL]
		//},


	},
	watch: {
		//filterInput: function (filter) {
		//	console.log("FP: watcher: ", filter);
		//}

		//"product.name": {
		//	handler() {
		//		this.product.meta.state = settings.STATE_UPDATED
		//	}, deep: true
		//},
	},
	methods: {
		// this.$store.commit(STORE_COMMIT.SET_PAGE_MENU_OPEN, false);
		//this.$store.dispatch({ type: PRODUCT_STORE_ACTION.GET_PRODUCT_LIST, data: { loginToken: this.$store.state.loginToken } });

		buttonLabel(productOptionSetId){

			if (this.dropshipActive){

				if (this.dropshipProductOptionSetId == productOptionSetId){
					return "VALD";
				}else{
					return "VÄLJ";
				}


			}

			return "KÖP";
			//dropshipProductOptionSetId

		},
		
		buttonSelectable(productOptionSetId){

			if (this.dropshipActive && this.dropshipProductOptionSetId == productOptionSetId) {

				return true;

			}

			if (this.dropshipActive && this.dropshipProductOptionSetId == null ) {

				return true;

			}

			if (!this.dropshipActive){
				return true;
			}

			return false;
			
		},

		buy(productOptionSet){
			this.$emit("buyProductOption", productOptionSet)
		},
		showDiscountInformationClicked(productOptionSetId){

			if (this.showDiscountInformationList?.includes(productOptionSetId)){
				this.showDiscountInformationList = this.showDiscountInformationList.filter(currentProductOptionSetId => currentProductOptionSetId != productOptionSetId )
			}else{
				this.showDiscountInformationList.push(productOptionSetId);
			}

		}

	},
	created() {


	}
};
</script>

<style scoped>

/* div#productOptionList table#desktop tbody tr.odd */
div#productOptionList table tbody tr td{
	padding:5px;
	height:40px;
	border-right:1px solid white;
	font-size:0.9rem;
	
}

div#desktop table thead tr th{
	background:var(--grey-4); 
	height:30px;
	padding:5px;
	font-size: 0.9rem;
}

.buyButton{
	display: block;
	margin: 0 auto;
	text-align: center;
	padding:5px;
 background:var(--bg-grey);
 border-radius: 5px;
 color:white;
 font-weight:bold;
 max-width: 80px; 
}

div.buyButton.selectable{
	background: var(--bg-message);
}



div#productOptionList div#desktop table tbody tr {
	background: var(--grey-1);
}

div#productOptionList div#desktop table tbody tr.odd{
	background:var(--grey-3);
}

div#productOptionList table#desktop table tbody tr:hover {
	background: var(--grey-4);
}

div#desktop table{
	border:0px solid red;
}


div#desktop table{
	display:table;
}


div#mobile {
	display: none;
}

div#mobile table{
	border:0px solid var(--grey-1);
}

div#mobile table.mobile-table-row tr {
	background: var(--grey-3);
}

div#mobile table.mobile-table-row tr.odd{
	background:var(--grey-1);
}

div#mobile table.mobile-table-row tr.odd td.label{
	width:200px;
}

div#mobile table.mobile-table-row tr td {
	padding:5px;
}

div#mobile table.mobile-table-row tr td.mobile-buy-button {
	background:transparent; 
	padding:0px;
}

div#mobile table.mobile-table-row tr td.mobile-buy-button div{
	background: var(--bg-message);
		text-align: center;
		color: white;
		font-weight: bold;
		padding:5px;
		border-radius: 5px;;
}

div.discountBadge{
	background: var(--bg-discount);
	color:white;
	font-weight: bold;
	border-radius: 3px;
	padding:3px;
	padding-left:5px;
	padding-right:5px;
	font-size: 80%;
	

}

@media (max-width: 768px) {

	div#productOptionList {
		border: 0px solid blue;
	}

	div#desktop {
		display: none;
	}

	div#mobile {
		display: table;
	}
}
	
</style>